
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ActivityFormValues, activityTypeOptions } from "../schema/activitySchema";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ActivityTypeSelectProps {
  form: UseFormReturn<ActivityFormValues>;
}

export const ActivityTypeSelect: React.FC<ActivityTypeSelectProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="activity_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Type d'activité</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Sélectionner un type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {activityTypeOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
